import { RpcElectronOperationResult } from './rpc-electron-model';

/**
 * Rpc Electron response sever side handler interface.
 */
export interface RpcElectronResponseHandler {
    handler(data: RpcElectronOperationResult): Promise<void>;
}
